import { IDateRange } from '../settings/dates/dateRangeProvider';

/**
 * @description evaluates a date range to make sure the necessary properties have values
 * @param dateRange
 * @returns
 */
export const isValidDateRange = (range: IDateRange): boolean => {
  if (!range || !range?.dateType) return false;
  if (range?.dateType?.value === 'custom') {
    if (!range?.dateRange) return false;
    if (!range?.dateRange.from?.value) return false;
    if (!range?.dateRange.to?.value) return false;
  }
  if (range?.dateType?.value === 'two-date') {
    return Boolean(range?.dateRange.from?.value);
  }
  return true;
};
